// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositeMergeVariableHints_wrap__XSIA+","label":"MicrositeMergeVariableHints_label__h5eCk","chip":"MicrositeMergeVariableHints_chip__BVk7e"};